import React from 'react'
import Skeleton from 'react-loading-skeleton';

export default function ResultLoadingPage() {
    return (
        <>
            <div className="mt-3 ml-5">
                <Skeleton width={70} height={40} />
            </div>
            <div className="container py-6 px-4 text-gray-800">
                <h1 className="text-3xl py-4 border-b mb-10">
                    <Skeleton width={200} height={36} />
                </h1>
                <div className="w-full overflow-x-scroll">
                    <div className="flex mb-5">
                        <Skeleton width={250} height={50} className="mr-5" />
                        <Skeleton width={250} height={50} />
                    </div>
                    <Skeleton count={13} height={25} />
                </div>
            </div>
        </>
    )
}
